import { device } from "../utils/deviceCheck";

/**
 * 웹접근성 - 장차법 관련 Script Event
 * @TODO 센스리더는 브라우저별 보이스 동작이 차이가 있기 때문에 추후 웹 브라우저별로 Script를 분기 처리해야함
 */
export const webAccess = {
    init: ()=>{
        webAccess.activeAuthPopup();
        webAccess.checkBoxKeyboardCtrl();
    },
    //간편인증 처음 팝업 시
    activeAuthPopup: ()=>{
        // var appendHTML = `<div class="a11y-hidden">간편인증 창이 열렸습니다.</div>`;
        // $("#oacxEmbededContents").prepend(appendHTML)
        if(device.isMobileUI()){
            webAccess.targetFocus("#oacxEmbededContents header button.close")
        }else{
            webAccess.targetFocus("#oacxEmbededContents");
        }
    },
    //각각의 동의항목 Enter Key 체크 이벤트
    checkBoxKeyboardCtrl: ()=>{
        $("#submitFm input[type=checkbox]").on('keydown',e=>{
            if(e.which === 13){
                $(e.currentTarget).click();
            }
        })
    },
    //focus Event 공통 사용
    targetFocus: (target)=>{
        $(target).focus();
        setTimeout(() => {
            $(target).focus();
        }, 100);
    },
    //Target Tag 안쪽의 가장 앞에 추가
    appendFocusMsg: (target,message)=>{
        const appendHtml = `<div class="focus-msg-box a11y-hidden">${message}</div>`;
        if($(target).find(".focus-msg-box").length == 0){
            $(target).append(appendHtml);
            $(target).focus();
        }
    },
    //Target Tag 안쪽의 가장 뒤에 추가
    prependFocusMsg: (target,message)=>{
        const appendHtml = `<div class="focus-msg-box a11y-hidden">${message}</div>`;
        if($("#"+target).find(".focus-msg-box").length == 0){
            $("#"+target).prepend(appendHtml);
            $(target).focus();
        }
    },
    removeFocusMsg: (target)=>{
        if($("#"+target).find(".focus-msg-box").length != 0){
            $("#"+target).find(".focus-msg-box").remove();
        }
    }
}